import { PermissionCode } from '@core-frontend/core-frontend';
import { lazy } from 'react';

import { AppRoutes } from '../AppRoutes';
import type { RouteProtectedWithPermissionObject } from '../types';

const InvitationDetailsPage = lazy(() =>
  import('@/pages/user-invitation').then((module) => ({
    default: module.InvitationDetailsPage,
  }))
);
const UserInvitationsPage = lazy(() =>
  import('@/pages/user-invitation').then((module) => ({
    default: module.UserInvitationsPage,
  }))
);

export const invitationRouter: RouteProtectedWithPermissionObject[] = [
  {
    path: AppRoutes.INVITATION_DETAILS,
    element: <InvitationDetailsPage />,
    permissions: [PermissionCode.ADD_USERS],
  },
  {
    path: AppRoutes.USER_INVITATIONS,
    element: <UserInvitationsPage />,
    permissions: [PermissionCode.VIEW_USERS],
  },
];
